import React from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const TriggerAltIcon: React.FC<IconProps> = (props) => {
  return (
    <BaseIcon {...props}>
      <path
        clipRule="evenodd"
        d="M17.3584 7.44452L10.8854 17H13.971C14.9327 17 15.6459 17.8922 15.4342 18.8303L14.1416 24.5557L20.6148 15H16.9069C16.7889 15 16.672 14.9792 16.5613 14.9385C16.0887 14.7651 15.8177 14.2678 15.9287 13.7763L17.3584 7.44452ZM17.1874 4.13097C18.117 2.7586 20.2575 3.68569 19.8924 5.30263L18.1543 13H21.5575C22.7606 13 23.4741 14.3452 22.7993 15.3412L14.3128 27.869C13.3832 29.2413 11.2427 28.3142 11.6078 26.6973L13.3455 19H9.94274C8.73966 19 8.02611 17.6547 8.70086 16.6587L17.1874 4.13097Z"
        fillRule="evenodd"
      />
    </BaseIcon>
  );
};
